/**
 * 空のチャット状態コンポーネント
 *
 * メッセージがない時に表示するウェルカム画面
 */

import { Stack, Text } from "@mantine/core";
import { Sparkles } from "lucide-react";

/**
 * 空のチャット状態
 */
export function EmptyChatState() {
  return (
    <Stack align="center" justify="center" h="100%" gap="md">
      <Sparkles
        size={48}
        strokeWidth={1.5}
        color="var(--mantine-color-blue-6)"
      />
      <Text size="lg" fw={500}>
        何かお手伝いしますか？
      </Text>
      <Text size="sm" c="dimmed" ta="center">
        現在のページに関する質問や、
        <br />
        操作の支援を行います。
      </Text>
    </Stack>
  );
}
